<template>
  <div class="table-responsive">
    <table class="data">
      <tr>
        <th class="selection"
            v-if="configuration.enableSelection">
          <p4a-checkbox :selected="allSelected"
                        @change="allSelected = !allSelected" />
        </th>
        <th v-for="column in orderedColumns"
            :key="column.column"
            :style="{ width: column.width + 'px' }"
            @drop="headerDropEnd(column, $event)"
            @dragover.prevent>
          <span>
            {{ column.name }}
          </span>
          <p4a-button :showIcon="true"
                      :onlyIconVisible="true"
                      :icon="'select-large'"
                      :isFilled="true"
                      @click="emitOrdinalRequest(column)" />
          <button class="draggable"
                  type="button"
                  v-bind:draggable="allowHeaderDragging"
                  @dragstart="headerDragStart(column, $event)">
            <p4a-icon :icon="'drag'" />
          </button>
          <!--<span class="drag-resize"
                v-if="allowDragResizing"
                :draggable="allowDragResizing"
                @dragstart="resizeColumnStart(column, $event)"
                @dragend="resizeColumnDrop(column, $event)"
                @dragover.prevent>&nbsp;
          </span>-->
        </th>
      </tr>
      <tr v-for="row in rows"
          :key="row.id">
        <td class="selection"
            v-if="configuration.enableSelection">
          <p4a-checkbox :selected="row.isChecked"
                        @change="toggleRow(row)" />
        </td>
        <td v-for="column in orderedColumns"
            :key="column.column"
            :style="{ width: column.width + 'px' }"
            @click="emitRowClick(row)">
          <p4a-icon v-if="column.type === 'icon'"
                           :icon="returnValue(row, column)"
                           :color="row.iconColor" />
          <span v-else>
            {{ returnValue(row, column) }}
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'Grid',
  props: {
    columns: Array,
    rows: Array,
    configuration: Object
  },
  created () {
    this.readColumns(this.columns)
  },
  data () {
    return {
      parsedColumns: [],
      allSelected: false
    }
  },
  computed: {
    orderedColumns () {
      return _.sortBy(this.parsedColumns, ['ordinal'])
    },
    allowHeaderDragging () {
      return this.configuration.allowHeaderDragging
    },
    allowDragResizing () {
      return this.configuration.allowDragResizing
    }
  },
  watch: {
    allSelected (newValue) {
      let self = this
      _.forEach(self.rows, row => {
        row.isChecked = newValue
      })
      self.emitSelectionChanged()
    }
  },
  methods: {
    readColumns (columns) {
      let self = this
      self.parsedColumns = []
      _.forEach(columns, column => {
        column.width = (column.width) ? column.width : 200
        column.selected = true
        self.parsedColumns.push(column)
      })
    },
    returnValue (row, column) {
      return row[column.key]
    },
    headerDragStart (column, event) {
      event.dataTransfer.setData('column', column.key)
    },
    headerDropEnd (column, event) {
      let draggedColumn = _.find(this.parsedColumns, { key: event.dataTransfer.getData('column') })
      let ordinalPlaceholder

      if (draggedColumn && draggedColumn.key !== column.key) {
        ordinalPlaceholder = column.ordinal
        column.ordinal = draggedColumn.ordinal
        draggedColumn.ordinal = ordinalPlaceholder
      }
    },
    resizeColumnStart (column, event) {
      column.pageX = event.pageX
    },
    resizeColumnDrop (column, event) {
      let difference, newWidth
      difference = event.pageX - column.pageX
      newWidth = column.width + difference
      column.width = (newWidth < 100) ? 100 : newWidth
    },
    toggleRow (row) {
      row.isChecked = !row.isChecked
      this.emitSelectionChanged()
    },
    emitOrdinalRequest (column) {
      this.$emit('ordinalRequest', column)
    },
    emitRowClick (row) {
      this.$emit('rowClicked', row)
    },
    emitSelectionChanged () {
      let selectedItems = _.filter(this.rows, { isChecked: true })
      this.$emit('selectionChanged', selectedItems)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styling/styling.scss';

  div.table-responsive {
    width: 100%;
    height: inherit;
    overflow: auto;

    table {
      width: max-content;
      height: inherit;
      border-collapse: collapse;
      border: rem(1) $dark-grey-background solid;

      tr {

        th {
          height: 30px;
          line-height: 30px;
          background: #EEE;
          min-width: 130px;
          font-weight: 500;
          font-size: 13px;
          color: #212121;
          border: rem(1) solid $dark-grey-background;
          border-width: 0 rem(1) rem(1) 0;

          button {
            height: 25px;
            width: 20px;
            margin: 0;
            background: none;
            line-height: 30px;
            box-sizing: border-box;
            vertical-align: top;

            &.draggable {
              float: right;
              width: 7px;

              &:hover svg {
                fill: #58585B;
              }

              svg {
                height: 18px;
                margin-top: 6px;
                fill: #AFAFAF;
              }
            }

            svg {
              height: 10px;
              width: auto;
              line-height: 30px;
            }
          }

          span {
            height: 30px;
            line-height: 30px;
            margin-right: 10px;
            float: left;

            &.drag-resize {
              cursor: col-resize;
              border-left: rem(2) solid $light-grey-font;
              float: right;
            }
          }
        }

        td {
          height: 25px;
          line-height: 25px;
          background: $light-grey-background;
          cursor: pointer;
          font-size: 13px;
          font-weight: 400;
          color: #58585b;
          border: rem(1) $dark-grey-background solid;
          border-width: 0 rem(1) 0 0;

          svg {
            line-height: 16px;
            height: 16px;
            vertical-align: sub;
          }
        }

        th, td {
          white-space: nowrap;
          text-align: left;
          font-family: 'Roboto', sans-serif;
          box-sizing: border-box;
          padding: 0 7px 0 15px;

          &.selection {
            padding-left: 5px;
            min-width: 20px;
            border-right: none;
          }
        }

        &:nth-child(odd) td {
          background: $medium-grey-background;
        }
      }
    }
  }

  .draggable {
    cursor: grab;
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Grid.vue